<h3 class="card-page-header">
  {{ sdfCardLabels?.addressPage?.header }} <br />
</h3>
<div *ngIf="isSdfCardFlow" class="card-page-header">
  <div class="card-inline-notification-wrapper">
    <div class="content-container">
      <img
        src="assets\images\master-notification.svg"
        alt="info-icon"
        class="info-icon"
      />
      <p class="content-body">{{ sdfCardLabels.common.notifcation.one }}.</p>
    </div>
  </div>
</div>
<form
  class="registration-form"
  [formGroup]="form"
  (ngSubmit)="submitted.emit(form.getRawValue())"
>
  <div class="registration-address-phone">
    <ng-container *ngFor="let field of addressFields; let fieldIndex = index">
      <ng-container
        *ngIf="
          field.name !== formFields.mobileNumber &&
          field.name !== formFields.mobileCountry
        "
      >
        <ng-container [ngSwitch]="field.controlType">
          <mat-form-field 
            *ngSwitchCase="controlTypes?.INPUT"
            class="custom-mat-form-field-input"
          >
            <mat-label>{{ field.fieldLabel }}</mat-label>
            <input
              matInput
              [type]="field.controlType!"
              [formControlName]="field.name!"
              [id]="field.name!"
            />
            <mat-error
              *ngIf="
                form.controls[field.name!]?.invalid &&
                (form.controls[field.name!]?.touched ||
                  form.controls[field.name!]?.dirty)
              "
            >
              <span
                *ngIf="
                  getErrorsMsg(field.fieldLabel, form.controls[field.name!])
                "
              >
                {{ errorMsgToDisplay }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field           
            *ngSwitchCase="controlTypes?.INPUT_LARGE" 
            class="large custom-mat-form-field-input"
          >
            <mat-label>{{ field.fieldLabel }} </mat-label>
            <input
              matInput
              [type]="field.controlType!"
              [formControlName]="field.name!"
              [id]="field.name!"
            />
            <mat-error
              *ngIf="
                form.controls[field.name!]?.invalid &&
                (form.controls[field.name!]?.touched ||
                  form.controls[field.name!]?.dirty)
              "
            >
              <span
                *ngIf="
                  getErrorsMsg(field.fieldLabel, form.controls[field.name!])
                "
              >
                {{ errorMsgToDisplay }}
              </span>
            </mat-error>
          </mat-form-field>

          <ng-container *ngIf="field.name !== formFields.state">
            <mat-form-field *ngSwitchCase="controlTypes?.SELECT"
              class="country-form-field custom-mat-form-field-select"
            >
              <mat-label>{{ field.fieldLabel }}</mat-label>
              <input
                [id]="field.name"
                type="text"
                [attr.aria-label]="field.fieldLabel"
                matInput
                [formControlName]="field.name!"
                [matAutocomplete]="autoRef"
              />
              <mat-icon class="arrow-icon" matSuffix>{{
                countryArrowIcon
              }}</mat-icon>
              <mat-autocomplete
                [displayWith]="
                  getSelectedOptionLabel.bind(this, countries, 'code')
                "
                (opened)="onAutoCompleteCountryPanelToggle(true)"
                (closed)="onAutoCompleteCountryPanelToggle(false)"
                #autoRef="matAutocomplete"
              >
                <ng-container *ngFor="let option of filteredCountries | async">
                  <mat-option [value]="option.name">
                    {{ option.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>

              <mat-error
                *ngIf="
                  form.controls[field.name!]?.invalid &&
                  (form.controls[field.name!]?.touched ||
                    form.controls[field.name!]?.dirty)
                "
              >
                <span
                  *ngIf="
                    getErrorsMsg(field.fieldLabel, form.controls[field.name!])
                  "
                >
                  {{ errorMsgToDisplay }}
                </span>
              </mat-error>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="field.name === formFields.state">
            <mat-form-field 
              *ngSwitchCase="controlTypes?.SELECT"
              class="custom-mat-form-field-select"
            >
              <mat-label>{{ field.fieldLabel }}</mat-label>
              <input
                [id]="field.name"
                type="text"
                [attr.aria-label]="field.fieldLabel"
                matInput
                [formControlName]="field.name!"
                [matAutocomplete]="autoCompleteRef"
              />
              <mat-icon class="arrow-icon" matSuffix>{{
                stateArrowIcon
              }}</mat-icon>
              <mat-autocomplete
                [displayWith]="
                  getSelectedOptionLabel.bind(this, stateOptions, 'code')
                "
                (opened)="onAutoCompleteStatePanelToggle(true)"
                (closed)="onAutoCompleteStatePanelToggle(false)"
                #autoCompleteRef="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of filteredStates | async"
                  [value]="option.name"
                >
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="
                  (form.controls[field.name!]?.invalid &&
                    (form.controls[field.name!]?.touched ||
                      form.controls[field.name!]?.dirty)) ||
                  form.controls[field.name]?.hasError('noSpaces')
                "
              >
                <span
                  *ngIf="
                    getErrorsMsg(field.fieldLabel, form.controls[field.name!])
                  "
                >
                  {{ errorMsgToDisplay }}
                </span>
              </mat-error>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <div class="registration-button-row">
    <button
      type="submit"
      class="w-full max-w-[327px]"
      [ngClass]="{
        'sign-in-disabled-btn-filled': form.invalid,
        'sign-in-red-btn-filled': !form.invalid
      }"
      [disabled]="form.invalid"
    >
      {{ sdfCardLabels.common.continue }}
    </button>
  </div>
</form>
